import { DOCUMENT, inject, Injectable } from '@angular/core';
import { CepStateService } from '@libs/shared/common';
import { ProductTrackingModel, TrackingProduct } from '@libs/shop/models';
import { getTrackingPagePath } from '../context';
import { TrackingMapperService } from '../mapper';
import { TrackingGoogleService } from '../services';

declare global {
  interface Window {
    shopPendingProductImpressions: TrackingProduct[];
  }
}

@Injectable({
  providedIn: 'root',
})
export class ProductImpressionTrackerService {
  private readonly impressionsPushTimeout: number = 500;
  private readonly impressionsBuffer: TrackingProduct[];
  private readonly trackingMapper: TrackingMapperService = inject(TrackingMapperService);
  private readonly document: Document = inject(DOCUMENT);
  private readonly cepStateService: CepStateService = inject(CepStateService);

  public constructor(
    private readonly trackingService: TrackingGoogleService,
  ) {
    window.shopPendingProductImpressions = window.shopPendingProductImpressions || [];
    this.impressionsBuffer = window.shopPendingProductImpressions;
  }

  public track(impression: TrackingProduct): void {
    if (this.impressionsBuffer.length === 0) {
      this.initTimeout();
    }

    this.impressionsBuffer.push(impression);
  }

  private initTimeout(): void {
    setTimeout(this.pushPendingImpressions.bind(this), this.impressionsPushTimeout);
  }

  private pushPendingImpressions(): void {
    const path: string = getTrackingPagePath(this.document);
    const allProducts: ProductTrackingModel[] = this.impressionsBuffer.flatMap(item => this.trackingMapper.mapTrackingProduct(item, path));
    const searchTerm: string | null = this.cepStateService.getProductSearchTerm(path);

    this.trackingService.trackProductImpressionEvent(allProducts, searchTerm);
    this.impressionsBuffer.length = 0;
  }
}
